<div class="footer-section">
        
    <img class="logo" routerLink="/about" src="../../assets/Logo/svg/Logo_8.svg">

    <!--<div class="social-icons">
        <img src="../../../assets/imgs/svg/facebook.svg" alt="">
        <img src="../../../assets/imgs/svg/twitter.svg" alt="">
        <img src="../../../assets/imgs/svg/instagram.svg" alt="">
    </div>-->

</div>